import { Box, Center, Group, Text, ThemeIcon } from '@mantine/core';
import { IconCompass } from '@tabler/icons-react';
import { Outlet } from 'react-router-dom';

import { t } from '../dictionary';

export const AuthLayout = () => (
    <Box
        mih='100vh'
        style={{
            background:
                'radial-gradient(1200px 600px at 80% -10%, var(--mantine-color-indigo-0), transparent), var(--mantine-color-gray-0)',
        }}
    >
        <Center mih='100vh' p='md'>
            <Box w='100%' maw={480}>
                <Group justify='center' gap='xs' mb='xl'>
                    <ThemeIcon size={34} radius='md' variant='filled' color='indigo'>
                        <IconCompass size={20} />
                    </ThemeIcon>
                    <Box>
                        <Text fw={700} size='md' lh={1.1}>
                            {t.common.brand}
                        </Text>
                        <Text size='xs' c='dimmed' lh={1.1}>
                            {t.common.portal}
                        </Text>
                    </Box>
                </Group>

                <Outlet />
            </Box>
        </Center>
    </Box>
);
